<template>
  <div id="img-container" style="width: 400px">
    <img :alt="$attrs.alt" :src="image"/>
  </div>
</template>

<script setup>
import ImageZoom from "js-image-zoom";

const props = defineProps({
  image: {
    type: String,
    default: "",
  },
});

const {locale} = useI18n();

onMounted(() => {
  setTimeout(() => {
    let options = {
      scale: 0.8,
      zoomPosition: locale.value === "ar" ? "left" : "right",
      offset: {vertical: 0, horizontal: 0},
      zoomContainer: document.getElementById("zoom-container"),
    };
    window.imageZoom = new ImageZoom(
        document.getElementById("img-container"),
        options
    );
  }, 500);
});

onUnmounted(() => {
  nextTick(() => {
    window?.imageZoom?.kill();
  })
});
</script>

<style></style>
